<nz-row>
  <nz-col nzSpan="24">
    <nz-list *ngIf="zeitUnterarts.result$ | async" nzSize="large" [nzLoading]="$loading | async">
      <nz-list-item *ngFor="let zeitUnterart of (zeitUnterarts.result$ | async).zeitUnterarts" (click)="select.emit(zeitUnterart)">
        <nz-list-item-meta [nzDescription]="ListDescription">
          <ng-template #ListDescription>
            <!--- << description    -->
            <!---    description >> -->
          </ng-template>
          <nz-list-item-meta-title>
            <a>
              <!--- << content    -->
              {{ zeitUnterart.name }}
              <nz-divider nzType="vertical"></nz-divider>
              <span nz-typography nzType="secondary">
                {{ zeitUnterart.zeitArt | type: (zeitUnterarts.zeitUnterartsZeitArt | async) }}
              </span>
              <!---    content >> -->
            </a>
          </nz-list-item-meta-title>
        </nz-list-item-meta>
        <ul nz-list-item-actions>
          <nz-list-item-action>
            <a><i nz-icon nzType="edit" nzTheme="outline"></i></a>
          </nz-list-item-action>
        </ul>
      </nz-list-item>
    </nz-list>
  </nz-col>
</nz-row>
